import React, { ReactElement } from 'react'

import { InputProps, Input } from '../Input'

export const EmailInput = (props: InputProps): ReactElement => (
  <Input type="email" {...props} />
)
